module.exports = __webpack_public_path__ + "static/media/icon-user-nopic-desktop.f8de0c03.svg";